<main>
  <!-- // List Details  -->
  <div *ngIf="!viewMode">
    <div class="student-head flex-wrap gap-2">
      <div
        class="d-flex align-items-center gap-3"
        style="cursor: pointer"
        (click)="goBack()"
      >
        <img src="assets/images/Buttons/arrow-left.svg" class="back-icon" />
        <div class="header-text student-text">Students</div>
      </div>
      <div class="d-flex gap-3 align-items-center">
        <!-- <div> -->
        <div class="search-container">
          <div class="search-icon">
            <img
              src="assets/icons/side-bar/search-normal.svg"
              alt="search"
              style="width: 18px; height: 18px"
            />
          </div>
          <input
            type="text"
            placeholder="Search here..."
            class="search-input"
            [(ngModel)]="search"
            (input)="updateSearch(search)"
            (keyup.enter)="applyFilter()"
            autocomplete="off"
          />
        </div>
        <!-- </div> -->
        <div class="mbl-view">
          <div *ngIf="userRoles.bulkUpload" class="w-100">
            <app-button
              context="upload"
              label="Bulk upload"
              (clicked)="openAddBulkDialog()"
            ></app-button>
          </div>
          <div *ngIf="userRoles.addNew" class="w-100">
            <app-button
              label="Add new student"
              (clicked)="
                teacherMode
                  ? openAddTeacherStudentDialog()
                  : openAddStudentDialog()
              "
            ></app-button>
          </div>

          <!-- <app-export-dropdown label="Export" [exportUrl]="exportUrl" [processData]="transformApiData"
                    [columns]="exportColumns" tableName="Students List" *ngIf="userRoles?.export">
                </app-export-dropdown> -->
          <div class="w-100">
            <app-export-dropdown
              label="Export"
              *ngIf="userRoles.export"
              [apiWise]="true"
              [exportApiUrl]="getExportApiUrl()"
              [tableName]="'Students'"
              [currentParams]="getCurrentExportParams()"
              [isSearch]="!!search"
              (export)="onExportComplete($event)"
            >
            </app-export-dropdown>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="table-card" #tableContainer>
        <app-table
          [columns]="selectedColumns"
          [data]="data"
          [actionTemplate]="actionButtonsTemplate"
          [loading]="loading"
          [clickableColumns]="studentClickableColumns"
          [sortableColumns]="selectedColumns"
          (cellClick)="onStudentCellClick($event)"
          (statusClick)="onStatusUpdate($event)"
          (downloadClick)="onDownloadConsent($event, '')"
          (rowClick)="onView($event)"
          tableName="Students list"
          [totalItems]="totalRecords"
          [currentPage]="currentPage"
          [pageSize]="pageSize"
          [sortColumn]="sortColumn"
          [sortDirection]="sortDirection"
          (pageChange)="onPageChange($event)"
          (sortClick)="onSort($event)"
          [serverSidePagination]="true"
        >
        </app-table>
      </div>
    </div>
  </div>

  <ng-template #schoolDetailsDialog>
    <div class="dialog-content p-4">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div class="header-text school-text">School details</div>
        <button
          type="button"
          class="btn-close"
          mat-dialog-close
          aria-label="Close"
        ></button>
      </div>

      <div *ngIf="schoolDialogLoading" class="spinner my-3"></div>

      <ng-container *ngIf="!schoolDialogLoading">
        <div class="d-grid gap-4">
          <div class="d-grid gap-1">
            <div class="main-text">School name</div>
            <div class="secondary-text">
              {{ selectedSchool?.schoolName || "-" }}
            </div>
          </div>
          <div class="d-grid gap-1">
            <div class="main-text">Type</div>
            <div class="secondary-text">
              {{ selectedSchool?.schoolType || "-" }}
            </div>
          </div>
          <div class="d-grid gap-1">
            <div class="main-text">Address</div>
            <div class="secondary-text">
              {{ formatSchoolAddress(selectedSchool) || "-" }}
            </div>
          </div>
          <div class="d-grid gap-1">
            <div class="main-text">Partnership status</div>
            <div class="secondary-text">
              {{
                selectedSchool?.isMouSchool === true
                  ? "Partnership School"
                  : selectedSchool?.isMouSchool === false
                    ? "Non-Partnership School"
                    : "-"
              }}
            </div>
          </div>
          <div class="d-grid gap-1">
            <div class="main-text">Partnership contact details</div>
            <div
              class="secondary-text"
              *ngIf="schoolContactData.length > 0; else noSchoolContacts"
            >
              <div *ngFor="let contact of schoolContactData">
                {{ formatSchoolContactSummary(contact) }}
              </div>
            </div>
            <ng-template #noSchoolContacts>
              <div class="secondary-text">-</div>
            </ng-template>
          </div>
        </div>

        <div class="mt-4">
          <div class="header-text school-text mb-3">Associated teachers</div>
          <app-table
            [columns]="schoolTeacherColumns"
            [data]="schoolTeacherData"
            [loading]="false"
          ></app-table>
        </div>
      </ng-container>
    </div>
  </ng-template>

  <div *ngIf="viewMode" class="d-flex flex-column gap-3">
    <div
      class="d-flex align-items-center gap-3"
      style="cursor: pointer"
      (click)="goBack()"
    >
      <img src="assets/images/Buttons/arrow-left.svg" class="back-icon" />
      <div class="header-text student-text">Back to students</div>
    </div>

    <div class="spinner my-3" *ngIf="loading"></div>

    <!-- Pending Verification banner — only when badge label is exactly 'Pending Verification' -->
    <div
      *ngIf="!loading && selectedStudent?.studentId && teacherMode && getStudentViewBadgeLabel(selectedStudent) === 'Pending Verification'"
      class="verification-banner"
    >
      <div class="d-flex align-items-center gap-3 flex-wrap">
        <div class="d-flex align-items-center gap-2">
          <span class="verification-banner-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
          </span>
          <span class="badge-pending-verification">Pending Verification</span>
        </div>
        <span class="verification-banner-text">
          Please verify student details first. Once verified, the system will automatically send the parent consent request.
        </span>
      </div>
      <button
        class="btn-verify-student"
        type="button"
        (click)="verifyStudent()"
        [disabled]="isVerifyingStudent"
      >
        <ng-container *ngIf="!isVerifyingStudent">Verify Student Details</ng-container>
        <ng-container *ngIf="isVerifyingStudent">
          <div class="d-flex align-items-center gap-2">
            <div class="down-spinner resend-spinner"></div>
            <span>Verifying...</span>
          </div>
        </ng-container>
      </button>
    </div>

    <!-- Verified attribution — shown above the card once verified -->
    <div
      *ngIf="!loading && selectedStudent?.isTeacherVerified"
      class="verified-attribution-above-card"
    >
      <span class="verified-attribution-tick">✓</span>
      Profile verified by
      <strong>{{ selectedStudent?.teacherVerifiedByName }}</strong>
      on {{ asUtc(selectedStudent?.teacherVerifiedAt) | brisbaneDate : "d MMM yyyy, h:mm a" }}
    </div>

    <div class="student-details" *ngIf="!loading">
      <div class="student-card">
        <div class="d-flex gap-4">
          <div>
            <div class="student-profile student-initials">
              {{
                (selectedStudent?.firstName?.[0] ?? "") +
                  (selectedStudent?.lastName?.[0] ?? "") | uppercase
              }}
            </div>
          </div>
          <div class="d-grid w-100 align-content-start">
            <div class="d-flex justify-content-between w-100">
              <div class="d-flex flex-column gap-2 w-100">
                <div class="d-flex gap-2 align-items-center">
                  <img
                    src="assets/images/male_student.svg"
                    class="icon_image"
                  />
                  <div class="text-head">
                    {{
                      selectedStudent?.firstName +
                        " " +
                        selectedStudent?.lastName
                    }}
                    <!-- Verified tick next to name -->
                    <span
                      *ngIf="selectedStudent?.isTeacherVerified"
                      class="verified-tick-badge"
                      [title]="'Verified by ' + (selectedStudent?.teacherVerifiedByName || 'teacher')"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="white" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                    </span>
                  </div>

                  <div
                    *ngIf="
                      getStudentViewBadgeLabel(selectedStudent) as studentBadge
                    "
                    [ngStyle]="{
                      'background-color':
                        getStudentViewBadgeColor(selectedStudent),
                      color: '#000',
                      padding: '3px 12px',
                      'border-radius': '20px',
                      'font-size': '13px',
                      'font-weight': '600',
                      'white-space': 'nowrap',
                    }"
                  >
                    {{ studentBadge }}
                  </div>
                </div>

                <div
                  class="d-flex gap-2 align-items-center"
                  *ngIf="selectedStudent?.schoolName"
                >
                  <img
                    src="assets/images/student_school.svg"
                    class="icon_image"
                  />
                  <div class="text-head" style="font-weight: 500">
                    <span
                      class="link-text"
                      (click)="goToSchool(selectedStudent)"
                    >
                      {{ selectedStudent?.schoolName }}
                    </span>
                    <span *ngIf="!selectedStudent?.schoolName">-</span>
                  </div>
                </div>

              </div>

              <div class="d-flex flex-column align-items-end gap-2">
                <div class="d-flex" style="gap: 1rem">
                <div class="d-grid gap-1" style="font-size: 12px">
                  <!-- ── STUDENTS UNDER 16: Parent handles both consents ── -->
                  <ng-container *ngIf="selectedStudent?.age < 16">
                    <div class="d-flex align-items-start gap-3">
                      <div
                        style="min-width: 8rem; font-size: 12px"
                        class="d-grid gap-1"
                      >
                        Account Consent
                        <div class="d-flex align-items-center gap-3">
                          <label
                            class="media-toggle-switch"
                            [ngClass]="
                              getConsentStatusClass(
                                selectedStudent?.parentApprovalStatus
                              )
                            "
                          >
                            <input
                              type="checkbox"
                              [checked]="
                                isConsentApproved(
                                  selectedStudent?.parentApprovalStatus
                                )
                              "
                              [disabled]="true"
                              readonly
                              (click)="$event.preventDefault()"
                            />
                            <span class="slider"></span>
                          </label>
                          <div
                            class="media-download-button"
                            (click)="
                              canDownloadConsent(
                                selectedStudent?.parentApprovalStatus
                              )
                                ? onDownloadConsent(selectedStudent, 'account')
                                : ''
                            "
                            [class.download-available]="
                              canDownloadConsent(
                                selectedStudent?.parentApprovalStatus
                              )
                            "
                            [class.disabled]="
                              !canDownloadConsent(
                                selectedStudent?.parentApprovalStatus
                              )
                            "
                            [style.cursor]="
                              canDownloadConsent(
                                selectedStudent?.parentApprovalStatus
                              )
                                ? 'pointer'
                                : 'default'
                            "
                            [ngClass]="
                              getConsentStatusClass(
                                selectedStudent?.parentApprovalStatus
                              )
                            "
                          >
                            <ng-container
                              *ngIf="
                                isDownloadingAccount;
                                else showAccountImage
                              "
                            >
                              <div class="down-spinner"></div>
                            </ng-container>
                            <ng-template #showAccountImage>
                              <img src="assets/images/download-media.svg" />
                            </ng-template>
                          </div>
                        </div>
                      </div>

                      <!-- Media consent: always shown -->
                      <div
                        style="min-width: 8rem; font-size: 12px"
                        class="d-grid gap-1"
                      >
                        Media Consent
                        <div class="d-flex align-items-center gap-3">
                          <label
                            class="media-toggle-switch"
                            [ngClass]="
                              getConsentStatusClass(
                                selectedStudent?.mediaConsentStatus
                              )
                            "
                          >
                            <input
                              type="checkbox"
                              [checked]="
                                isConsentApproved(
                                  selectedStudent?.mediaConsentStatus
                                )
                              "
                              [disabled]="true"
                              readonly
                              (click)="$event.preventDefault()"
                            />
                            <span class="slider"></span>
                          </label>
                          <div
                            class="media-download-button"
                            (click)="
                              canDownloadConsent(
                                selectedStudent?.mediaConsentStatus
                              )
                                ? onDownloadConsent(selectedStudent, 'media')
                                : ''
                            "
                            [class.disabled]="
                              !canDownloadConsent(
                                selectedStudent?.mediaConsentStatus
                              )
                            "
                            [style.cursor]="
                              canDownloadConsent(
                                selectedStudent?.mediaConsentStatus
                              )
                                ? 'pointer'
                                : 'default'
                            "
                            [ngClass]="
                              getConsentStatusClass(
                                selectedStudent?.mediaConsentStatus
                              )
                            "
                          >
                            <ng-container
                              *ngIf="isDownloadingMedia; else showMediaImage"
                            >
                              <div class="down-spinner"></div>
                            </ng-container>
                            <ng-template #showMediaImage>
                              <img src="assets/images/download-media.svg" />
                            </ng-template>
                          </div>
                        </div>
                      </div>

                      <!-- Resend button: only when account consent is NOT approved -->
                      <div
                        *ngIf="shouldShowResendParentConsentButton()"
                        class="d-grid gap-1 consent-resend-block"
                      >
                        <div
                          class="consent-action-spacer"
                          aria-hidden="true"
                        ></div>
                        <span
                          style="display: inline-block"
                          [title]="
                            resendCooldownActive
                              ? 'Please wait before resending reminder'
                              : ''
                          "
                        >
                          <button
                            class="resend-btn"
                            type="button"
                            (click)="resendParentConsent()"
                            [disabled]="
                              isResendingParentConsent || resendCooldownActive
                            "
                          >
                            <ng-container
                              *ngIf="
                                !isResendingParentConsent;
                                else resendingUnder16
                              "
                            >
                              Resend parental consent request
                              <span *ngIf="resendCooldownActive">
                                ({{ resendCooldownSeconds }}s)</span
                              >
                            </ng-container>
                          </button>
                        </span>
                        <ng-template #resendingUnder16>
                          <div
                            class="d-flex align-items-center justify-content-center gap-2"
                          >
                            <div class="down-spinner resend-spinner"></div>
                            <span>Sending...</span>
                          </div>
                        </ng-template>
                        <div
                          class="time-stamp"
                          *ngIf="selectedStudent?.mediaConsentSentAt"
                        >
                          Request sent on
                          {{
                            asUtc(selectedStudent?.mediaConsentSentAt)
                              | brisbaneDate: "MMM d, yyyy 'at' h:mm a"
                          }}
                        </div>
                      </div>

                      <!-- Reset consent: Super Admin only, when consent is Approved/Declined -->
                      <div
                        *ngIf="shouldShowResetParentConsentButton()"
                        class="d-grid gap-1 consent-resend-block"
                      >
                        <div class="consent-action-spacer" aria-hidden="true"></div>
                        <button
                          class="resend-btn reset-consent-btn"
                          type="button"
                          (click)="resetParentConsent()"
                          [disabled]="isResettingParentConsent"
                        >
                          <ng-container *ngIf="!isResettingParentConsent; else resettingConsentUnder16">
                            Reset Consent Decision
                          </ng-container>
                        </button>
                        <ng-template #resettingConsentUnder16>
                          <div class="d-flex align-items-center justify-content-center gap-2">
                            <div class="down-spinner resend-spinner"></div>
                            <span>Resetting...</span>
                          </div>
                        </ng-template>
                      </div>
                    </div>
                  </ng-container>

                  <!-- ── STUDENTS 16 AND ABOVE: Student handles media consent ── -->
                  <ng-container *ngIf="selectedStudent?.age >= 16">
                    <div class="d-flex align-items-start gap-3">
                      <div
                        style="min-width: 8rem; font-size: 12px"
                        class="d-grid gap-1"
                      >
                        Account Consent
                        <div class="d-flex align-items-center gap-3">
                          <label
                            class="media-toggle-switch"
                            [ngClass]="
                              getConsentStatusClass(
                                selectedStudent?.parentApprovalStatus
                              )
                            "
                          >
                            <input
                              type="checkbox"
                              [checked]="
                                isConsentApproved(
                                  selectedStudent?.parentApprovalStatus
                                )
                              "
                              [disabled]="true"
                              readonly
                              (click)="$event.preventDefault()"
                            />
                            <span class="slider"></span>
                          </label>
                          <div
                            class="media-download-button"
                            (click)="
                              canDownloadConsent(
                                selectedStudent?.parentApprovalStatus
                              )
                                ? onDownloadConsent(selectedStudent, 'account')
                                : ''
                            "
                            [class.download-available]="
                              canDownloadConsent(
                                selectedStudent?.parentApprovalStatus
                              )
                            "
                            [class.disabled]="
                              !canDownloadConsent(
                                selectedStudent?.parentApprovalStatus
                              )
                            "
                            [style.cursor]="
                              canDownloadConsent(
                                selectedStudent?.parentApprovalStatus
                              )
                                ? 'pointer'
                                : 'default'
                            "
                            [ngClass]="
                              getConsentStatusClass(
                                selectedStudent?.parentApprovalStatus
                              )
                            "
                          >
                            <ng-container
                              *ngIf="
                                isDownloadingAccount;
                                else showAccountImage16
                              "
                            >
                              <div class="down-spinner"></div>
                            </ng-container>
                            <ng-template #showAccountImage16>
                              <img src="assets/images/download-media.svg" />
                            </ng-template>
                          </div>
                        </div>
                      </div>

                      <!-- Media consent: always shown; editable for CSQ roles (AC2/AC4) -->
                      <div
                        style="min-width: 8rem; font-size: 12px"
                        class="d-grid gap-1"
                      >
                        Media Consent
                        <div class="d-flex align-items-center gap-3">
                          <!-- CSQ editable toggle (AC4 / AC5) -->
                          <ng-container *ngIf="userViewRoles?.changeMediaConsent; else mediaToggleReadOnly16">
                            <label
                              class="media-toggle-switch"
                              [ngClass]="[getConsentStatusClass(selectedStudent?.mediaConsentStatus), isUpdatingMediaConsent ? '' : 'csq-editable']"
                              [title]="isUpdatingMediaConsent ? 'Updating…' : 'Click to toggle Media Consent'"
                            >
                              <input
                                type="checkbox"
                                [checked]="isConsentApproved(selectedStudent?.mediaConsentStatus)"
                                [disabled]="isUpdatingMediaConsent"
                                (change)="onManualMediaConsentChange($any($event.target).checked)"
                              />
                              <span class="slider"></span>
                            </label>
                          </ng-container>
                          <!-- Read-only toggle for non-CSQ roles (AC3) -->
                          <ng-template #mediaToggleReadOnly16>
                            <label
                              class="media-toggle-switch"
                              [ngClass]="getConsentStatusClass(selectedStudent?.mediaConsentStatus)"
                            >
                              <input
                                type="checkbox"
                                [checked]="isConsentApproved(selectedStudent?.mediaConsentStatus)"
                                [disabled]="true"
                                readonly
                                (click)="$event.preventDefault()"
                              />
                              <span class="slider"></span>
                            </label>
                          </ng-template>
                          <div
                            class="media-download-button"
                            (click)="
                              canDownloadConsent(
                                selectedStudent?.mediaConsentStatus
                              )
                                ? onDownloadConsent(selectedStudent, 'media')
                                : ''
                            "
                            [class.disabled]="
                              !canDownloadConsent(
                                selectedStudent?.mediaConsentStatus
                              )
                            "
                            [style.cursor]="
                              canDownloadConsent(
                                selectedStudent?.mediaConsentStatus
                              )
                                ? 'pointer'
                                : 'default'
                            "
                            [ngClass]="
                              getConsentStatusClass(
                                selectedStudent?.mediaConsentStatus
                              )
                            "
                          >
                            <ng-container
                              *ngIf="isDownloadingMedia; else showMediaImage16"
                            >
                              <div class="down-spinner"></div>
                            </ng-container>
                            <ng-template #showMediaImage16>
                              <img src="assets/images/download-media.svg" />
                            </ng-template>
                          </div>
                        </div>
                      </div>

                      <!-- Resend button: only when account consent is NOT approved -->
                      <div
                        *ngIf="shouldShowResendParentConsentButton()"
                        class="d-grid gap-1 consent-resend-block"
                      >
                        <div
                          class="consent-action-spacer"
                          aria-hidden="true"
                        ></div>
                        <span
                          style="display: inline-block"
                          [title]="
                            resendCooldownActive
                              ? 'Please wait before resending reminder'
                              : ''
                          "
                        >
                          <button
                            class="resend-btn"
                            type="button"
                            (click)="resendParentConsent()"
                            [disabled]="
                              isResendingParentConsent || resendCooldownActive
                            "
                          >
                            <ng-container
                              *ngIf="
                                !isResendingParentConsent;
                                else resendingAbove16
                              "
                            >
                              Resend parental consent request
                              <span *ngIf="resendCooldownActive">
                                ({{ resendCooldownSeconds }}s)</span
                              >
                            </ng-container>
                          </button>
                        </span>
                        <ng-template #resendingAbove16>
                          <div
                            class="d-flex align-items-center justify-content-center gap-2"
                          >
                            <div class="down-spinner resend-spinner"></div>
                            <span>Sending...</span>
                          </div>
                        </ng-template>
                        <div
                          class="time-stamp"
                          *ngIf="selectedStudent?.mediaConsentSentAt"
                        >
                          Request sent on
                          {{
                            asUtc(selectedStudent?.mediaConsentSentAt)
                              | brisbaneDate: "MMM d, yyyy 'at' h:mm a"
                          }}
                        </div>
                      </div>

                      <!-- Reset consent: Super Admin only, when consent is Approved/Declined -->
                      <div
                        *ngIf="shouldShowResetParentConsentButton()"
                        class="d-grid gap-1 consent-resend-block"
                      >
                        <div class="consent-action-spacer" aria-hidden="true"></div>
                        <button
                          class="resend-btn reset-consent-btn"
                          type="button"
                          (click)="resetParentConsent()"
                          [disabled]="isResettingParentConsent"
                        >
                          <ng-container *ngIf="!isResettingParentConsent; else resettingConsentAbove16">
                            Reset Consent Decision
                          </ng-container>
                        </button>
                        <ng-template #resettingConsentAbove16>
                          <div class="d-flex align-items-center justify-content-center gap-2">
                            <div class="down-spinner resend-spinner"></div>
                            <span>Resetting...</span>
                          </div>
                        </ng-template>
                      </div>
                    </div>
                  </ng-container>
                </div>

                <div
                  class="edit-button"
                  (click)="onEdit(selectedStudent)"
                  *ngIf="userViewRoles?.edit"
                >
                  <img
                    alt="edit"
                    class="edit-img"
                    src="assets/images/Buttons/edit-button.svg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

        <div class="details-section">
          <!-- <div class="d-grid gap-1">
            <div class="main-text">PD points</div>
            <div class="secondary-text">{{ selectedStudent?.pdPoints }}</div>
          </div> -->

          <div class="d-grid gap-1" *ngIf="!selectedStudent?.isAnonymised">
            <div class="main-text">School email</div>
            <div class="secondary-text">{{ selectedStudent?.schoolEmail }}</div>
          </div>

          <div class="d-grid gap-1" *ngIf="!selectedStudent?.isAnonymised">
            <div class="main-text">Personal email</div>
            <div class="secondary-text">
              {{ selectedStudent?.personalEmail }}
            </div>
          </div>

          <div class="d-grid gap-1" *ngIf="!selectedStudent?.isAnonymised">
            <div class="main-text">Year level</div>
            <div class="secondary-text">
              {{ selectedStudent?.yearLevelName }}
            </div>
          </div>

          <!-- <div class="d-grid gap-1">
            <div class="main-text">Status</div>
            <div class="secondary-text">{{ selectedStudent?.status }}</div>
          </div>
          <div class="d-grid gap-1">
            <div class="main-text">School</div>
            <div class="secondary-text">{{ selectedStudent?.schoolName }}</div>
          </div> -->
        </div>

        <div class="details-section" *ngIf="!selectedStudent?.isAnonymised">
          <div class="d-grid gap-1">
            <div class="main-text">Date of birth</div>
            <div class="secondary-text">
              {{ selectedStudent?.dateOfBirth | brisbaneDate: "dd/MM/yyyy" }}
            </div>
          </div>

          <div class="d-grid gap-1">
            <div class="main-text">Parent / Guardian name</div>
            <div class="secondary-text">
              {{ selectedStudent?.parentGuardianFullName }}
            </div>
          </div>

          <div class="d-grid gap-1">
            <div class="main-text">Parent / Guardian email</div>
            <div class="secondary-text">
              {{ selectedStudent?.parentGuardianEmail }}
            </div>
          </div>
        </div>
        <div
          class="details-section"
          style="border-bottom: 1px solid #ffffff80; padding-bottom: 1rem"
          *ngIf="!selectedStudent?.isAnonymised"
        >
          <div class="d-grid gap-1">
            <div class="main-text">Region</div>
            <div class="secondary-text">{{ selectedStudent?.region }}</div>
          </div>

          <div class="d-grid gap-1">
            <div class="main-text">Ethinicity</div>
            <div class="secondary-text">
              {{ selectedStudent?.ethnicityName }}
            </div>
          </div>
          <div class="d-grid gap-1">
            <div class="main-text">Gender</div>
            <div class="secondary-text text-capitalize">
              {{ selectedStudent?.gender }}
            </div>
          </div>
        </div>
        <div
          class="secondary-text"
          *ngIf="!selectedStudent?.isAnonymised"
          style="
            padding: 6px 8px;
            background-color: #7085a2;
            max-width: 13rem;
            text-align: center;
          "
        >
          Course background
        </div>

        <div style="display: grid; grid-template-columns: 1fr 1fr" *ngIf="!selectedStudent?.isAnonymised">
          <div class="list-container">
            Last 12 Months
            <div
              *ngIf="filteredPast && filteredPast.length > 0; else noCourses"
              class="mt-3"
            >
              <div class="list-details">
                <ol>
                  <li *ngFor="let past of filteredPast">
                    {{ past?.courseName ?? "-" }}
                  </li>
                </ol>
              </div>
            </div>
            <ng-template #noCourses>
              <div class="no-courses">No courses available</div>
            </ng-template>
          </div>
          <div class="list-container">
            Completed / Currently Enrolled
            <div
              *ngIf="
                filteredComp && filteredComp.length > 0;
                else noCompCourses
              "
              class="mt-3"
            >
              <div class="list-details">
                <ol>
                  <li *ngFor="let compt of filteredComp">
                    {{ compt?.courseName }}
                  </li>
                </ol>
              </div>
            </div>
            <ng-template #noCompCourses>
              <div class="no-courses">No courses available</div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

    <!-- Activities section – teacher view only -->
    <div class="table-details" *ngIf="teacherMode && !loading">
      <div class="settings-bg">
        <div class="d-flex justify-content-between align-items-center" style="padding: 1rem 1rem 0.5rem">
          <h2 class="upcoming-event-text">Activities</h2>
        </div>
        <div class="table-page">
          <app-table
            [columns]="teacherActivitiesColumns"
            [data]="teacherActivitiesData"
            [loading]="teacherActivitiesLoading"
            [actionTemplate]="teacherActivitiesActionTpl"
          ></app-table>
        </div>
      </div>
    </div>

    <!-- <div class="student-details" *ngIf="userViewRoles.schoolView && !loading">
      <div class="points-text">
        Points Achieved
      </div>
      <div class="points-card">
        <div class="details">        
          <div class="d-flex flex-column align-items-center">
            <span class="total-text">Total Points</span>
            <span class="total-score">{{
              pointsStudent?.totalPoints || 0
            }}</span>
          </div>
        </div>

        <div class="details-second">        
          <div class="d-flex flex-column align-items-center">
            <span class="total-text">Event Attendance</span>
            <span class="total-text">{{
              pointsStudent?.eventAttendancePoints || 0
            }}</span>
          </div>
        </div>
        <div class="details-second">        
          <div class="d-flex flex-column align-items-center">
            <span class="total-text">Work experience</span>
            <span class="total-text">{{
              pointsStudent?.workExperiencePoints || 0
            }}</span>
          </div>
        </div>
        <div class="details-second">        
          <div class="d-flex flex-column align-items-center">
            <span class="total-text">Assignment Completed</span>
            <span class="total-text">{{
              pointsStudent?.assignmentCompleted || 0
            }}</span>
          </div>
        </div>      
      </div>
    </div> -->

    <div class="table-details" *ngIf="userViewRoles.schoolView && !loading">
      <div class="settings-bg">
        <div class="segment-buttons">
          <button
            [disabled]="selectedSegment === 'associatedTeachers'"
            [class.active]="selectedSegment === 'associatedTeachers'"
            (click)="switchSegment('associatedTeachers')"
          >
            Associated teachers
          </button>
          <button
            [disabled]="selectedSegment === 'recentlyRegisteredEvents'"
            [class.active]="selectedSegment === 'recentlyRegisteredEvents'"
            (click)="switchSegment('recentlyRegisteredEvents')"
          >
            Recently registered events
          </button>
          <button
            [disabled]="selectedSegment === 'eventattended'"
            [class.active]="selectedSegment === 'eventattended'"
            (click)="switchSegment('eventattended')"
          >
            Events attended
          </button>
        </div>

        <div class="table-page">
          <div *ngIf="selectedSegment === 'associatedTeachers'">
            <app-table
              [columns]="teacherColumn"
              [data]="associatedTeachersData"
              [loading]="tabelLoading"
            ></app-table>
          </div>
          <div *ngIf="selectedSegment === 'recentlyRegisteredEvents'">
            <app-table
              [columns]="recentEventColumns"
              [data]="upcomingEventsData"
              [loading]="tabelLoading"
            ></app-table>
          </div>
          <div *ngIf="selectedSegment === 'eventattended'">
            <app-table
              [columns]="attendedEventColumns"
              [data]="eventAttendedsData"
              [loading]="tabelLoading"
            ></app-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<ng-template #actionButtons let-row>
  <div style="display: flex; gap: 0.8rem; justify-content: center">
    <img
      class="action-button"
      *ngIf="userRoles.listItem.view"
      (click)="onView(row)"
      src="assets/images/Buttons/view-button.svg"
      alt="View"
    />
    <img
      class="action-button"
      *ngIf="userRoles.listItem.edit"
      (click)="onEdit(row)"
      src="assets/images/Buttons/edit-button.svg"
      alt="Edit"
    />
    <img
      class="action-button"
      *ngIf="userRoles.listItem.delete"
      (click)="onDelete(row)"
      src="assets/images/Buttons/delete-button.svg"
      alt="Delete"
    />
  </div>
</ng-template>

<ng-template #statusButton let-row>
  <div [ngClass]="row?.status ? 'active-text' : 'inactive-text'">
    {{ row?.status ? "Active" : "Inactive" }}
  </div>
</ng-template>

<ng-template #actionButtonsStudent let-row>
  <div style="display: flex; gap: 0.8rem; justify-content: center">
    <img
      class="action-button"
      src="assets/images/Buttons/view-button.svg"
      alt="View"
    />
  </div>
</ng-template>

<ng-template #teacherActivitiesActionTpl let-row>
  <div style="display: flex; gap: 0.8rem; justify-content: center">
    <img
      class="action-button"
      (click)="onViewActivityRow(row)"
      src="assets/images/Buttons/view-button.svg"
      alt="View"
    />
  </div>
</ng-template>
